import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, X } from "lucide-react";
import { API } from "../lib/constants";

const BookingSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [bookingDetails, setBookingDetails] = useState(null);
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    const checkPayment = async () => {
      if (!sessionId) {
        setStatus("error");
        return;
      }

      try {
        let attempts = 0;
        const maxAttempts = 5;
        
        const poll = async () => {
          const response = await axios.get(`${API}/checkout/status/${sessionId}`);
          
          if (response.data.payment_status === "paid") {
            setStatus("success");
            setBookingDetails(response.data);
          } else if (response.data.status === "expired" || attempts >= maxAttempts) {
            setStatus("error");
          } else {
            attempts++;
            setTimeout(poll, 2000);
          }
        };
        
        poll();
      } catch (error) {
        console.error("Error checking payment:", error);
        setStatus("error");
      }
    };

    checkPayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="booking-success-page">
      <div className="max-w-md w-full glass rounded-2xl p-8 text-center">
        {status === "checking" && (
          <>
            <div className="w-16 h-16 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto mb-6" />
            <h1 className="text-2xl font-bold mb-2">Processing Payment...</h1>
            <p className="text-slate-400">Please wait while we confirm your booking.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold mb-2 text-green-400">Booking Confirmed!</h1>
            <p className="text-slate-400 mb-6">
              Your $20 deposit has been received. We'll be in touch shortly to confirm your appointment.
            </p>
            <a 
              href="/"
              className="inline-block btn-primary-glow text-slate-900 font-semibold px-6 py-3 rounded-full"
            >
              Return Home
            </a>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <X className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold mb-2 text-red-400">Payment Issue</h1>
            <p className="text-slate-400 mb-6">
              There was an issue processing your payment. Please try again or contact us.
            </p>
            <a 
              href="/"
              className="inline-block btn-secondary font-semibold px-6 py-3 rounded-full"
            >
              Return Home
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingSuccessPage;
